import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { postBulkAdditionMerchantOrgBlockLists } from '@src/api'
import { DefaultApiPostBulkAdditionMerchantOrgBlockListsRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

import { PostBulkAdditionMerchantOrgBlockListsError } from './type'

export const usePostBulkAdditionMerchantOrgBlockLists = () => {
  const { axiosInstance } = useAxios()

  return useMutation<
    unknown,
    AxiosResponse<PostBulkAdditionMerchantOrgBlockListsError>,
    DefaultApiPostBulkAdditionMerchantOrgBlockListsRequest
  >({
    mutationFn: (
      params: DefaultApiPostBulkAdditionMerchantOrgBlockListsRequest
    ) => postBulkAdditionMerchantOrgBlockLists(axiosInstance, params),
  })
}
